import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { TextStyle } from "react-native";
import { Caption, useTheme } from "react-native-paper";
import useCountDown from ".";
import { spacing } from "@styles/spacing";

interface CountdownProps {
  timer?: number;
  errorEndOTP?: boolean;
  onComplete?: () => void;
}

export const Countdown = (props: CountdownProps) => {
  const { timer = 120000, onComplete = () => {}, errorEndOTP = false } = props;
  const { t } = useTranslation();
  const [timeLeft, { start, reset }] = useCountDown(timer);
  const { colors } = useTheme();
  const [isStart, setStart] = React.useState(false);

  const textStyle: TextStyle = {
    fontStyle: "italic",
    fontWeight: "500",
    color: colors.blackText,
    textAlign: "center",
    marginTop: spacing.massive,
  };

  const countDownTextStyle: TextStyle = {
    fontWeight: "700",
    color: colors.error,
  };

  React.useEffect(() => {
    setStart(true);
    start();
  }, [start]);

  React.useEffect(() => {
    if ((timeLeft === 0 || errorEndOTP) && isStart) {
      setStart(false);
      onComplete();
    }
  }, [isStart, onComplete, timeLeft, errorEndOTP]);

  return (
    <>
      {timeLeft > 0 && !errorEndOTP ? (
        <Caption style={textStyle}>
          {t("SM_OTP_MA_OTP_SMART_TIEU_DE")} <Caption style={countDownTextStyle}>{moment.utc(timeLeft).format("mm:ss")}</Caption>
        </Caption>
      ) : (
        !errorEndOTP && <Caption style={[textStyle, { color: colors.error }]}>{t("COMMON_MA_OTP_HET_HIEU_LUC")}</Caption>
      )}
    </>
  );
};
